import isNil from "lodash/isNil";
import isString from "lodash/isString";

export const valueFormatterDate = (params, returnValue) => {
  const d = params?.value;

  if (isNil(d) || !isString(d)) {
    return returnValue;
  }

  const date = new Date(d);
  if (isNaN(date.getTime())) {
    return returnValue;
  }

  // `date`-type columns store calendar dates as UTC midnight (see DateInput,
  // which both writes UTC midnight and reads it back via UTC getters). Format
  // by the UTC components so the displayed day matches what was picked —
  // otherwise a UTC-midnight value renders one day early in negative-offset
  // (e.g. US) time zones.
  const m = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  const y = date.getUTCFullYear();
  return `${m}/${day}/${y}`;
};
